import React, { JSX, useState } from 'react';
import './OrderDocuments.css';
import { localized } from '../config/localization';
import { Button } from './Button/Button';
import { Download } from '../assets/svg/Download';
import { Bin } from '../assets/svg/Bin';
import { Modal } from './Modal';
import { BlechconDocument, BlechconOrder } from '../blechcon';
import { presentDownloadDialogForS3Key } from './helper';

type Props = {
  readonly order: BlechconOrder;
  readonly onChangeDocuments?: (documents: BlechconDocument[]) => void;
};

export function OrderDocuments({ order, onChangeDocuments }: Props): JSX.Element | null {
  const [documentForDeletion, setDocumentForDeletion] = useState<BlechconDocument | null>(null);

  const removeDocument = (document: BlechconDocument | null) => {
    if (!document) {
      return;
    }
    const documents = order.documents.filter((it: BlechconDocument) => it.data !== document.data);
    onChangeDocuments && onChangeDocuments(documents);
    setDocumentForDeletion(null);
  };

  if (order.documents?.length === 0) {
    return null;
  }

  return (
    <>
      {documentForDeletion && (
        <Modal
          title={localized.REMOVE_FILE}
          successDisabled={false}
          onCancel={{
            label: localized.ABORT,
            execute: () => {
              setDocumentForDeletion(null);
            },
          }}
          onSuccess={{
            label: localized.CONFIRM,
            execute: () => removeDocument(documentForDeletion),
          }}
        >
          <div className="modal-text">{localized.REMOVE_FILE_CONFIRMATION}</div>
        </Modal>
      )}

      <table className="table">
        <thead>
          <tr>
            <td>{localized.FILE_NAME}</td>
            <td />
          </tr>
        </thead>
        <tbody className="no-hover">
          {order.documents?.map((document, index: number) => (
            <tr key={index}>
              <td className="info__bold">{document.name}</td>
              <td className="order-documents__cell-actions">
                <Button
                  onClick={() => {
                    if (document.data) {
                      presentDownloadDialogForS3Key(document.name, document.data);
                    }
                  }}
                >
                  {<Download fill="currentColor" />}&nbsp;{localized.DOWNLOAD}
                </Button>

                {onChangeDocuments && (
                  <Button
                    className="order-documents__button-remove"
                    onClick={() => {
                      setDocumentForDeletion(document);
                    }}
                    danger
                  >
                    {<Bin height={16} width={16} />}&nbsp;{localized.REMOVE}
                  </Button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}
